// @flow
import * as React from 'react';
import { type Map } from 'esm-web-pro/containers/map/types';

export const MapContext: React.Context<Map> = React.createContext(null);

export default MapContext;
